export type LocaleId =
  | 'zh_CN'
  | 'zh_HK'
  | 'en_US'
  | 'ru_RU'
  | 'es_ES'
  | 'fr_FR'
  | 'ja_JP';
export type Language = LocaleId;

export const SUPPORTED_LOCALES: readonly LocaleId[] = [
  'zh_CN',
  'zh_HK',
  'en_US',
  'ru_RU',
  'es_ES',
  'fr_FR',
  'ja_JP',
];

export const DEFAULT_LOCALE: LocaleId = 'zh_CN';
export const FALLBACK_LOCALE: LocaleId = 'en_US';
export const LOCALE_STORAGE_KEY = 'wavelink-locale';

export const SITE_LANGUAGE_OPTIONS: Array<{ value: LocaleId; label: string }> = [
  { value: 'zh_CN', label: '简体中文' },
  { value: 'zh_HK', label: '繁體中文' },
  { value: 'en_US', label: 'English' },
  { value: 'ru_RU', label: 'Русский' },
  { value: 'es_ES', label: 'Español' },
  { value: 'fr_FR', label: 'Français' },
  { value: 'ja_JP', label: '日本語' },
];

export type TranslateParams = Record<string, string | number>;
export type LocaleModule<T extends { [Key in keyof T]: string }> = Record<LocaleId, T>;

const supportedLocaleSet: ReadonlySet<string> = new Set(SUPPORTED_LOCALES);

export function isLocaleId(value: unknown): value is LocaleId {
  return typeof value === 'string' && supportedLocaleSet.has(value);
}
